import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ENDPOINTS } from '../constants/endpoints';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable()
export class FeatureFlagGuard {
    constructor(private router: Router, private featureFlagService: FeatureFlagService) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        /* eslint-disable @typescript-eslint/no-unsafe-assignment */
        const feature: string = route.data['feature'];
        const permissionsLevel = route.data['featureFlagPermissionLevel'];
        /* eslint-ensable @typescript-eslint/no-unsafe-assignment */

        const isEnabled = await this.featureFlagService.isFeatureEnabled(
            feature,
            undefined,
            undefined,
            permissionsLevel
        );

        if (!isEnabled) {
            this.router.navigate([ENDPOINTS.urls.pageNotFound]).catch(() => {});
        }

        return isEnabled;
    }
}
